import {
    CounterClockwiseClockIcon,
    UpdateIcon,
} from '@radix-ui/react-icons';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import api from '../../lib/api';
import { Button } from '../ui/button';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";
import { DropdownMenuItem } from '../ui/dropdown-menu';
import {
    Form,
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from '../ui/form';
import { Input } from '../ui/input';
import { toast } from '../ui/use-toast';

function ImportBunniesDialog({ fetchBunnies }) {
    const form = useForm();

    const [isLoading, setIsLoading] = useState(false);
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const [formData, setFormData] = useState({
        legacyMembership: '',
    });

    const handleChange = async (e) => {
        e.preventDefault();
        if (isLoading) return;

        // Validate that both timekeepers are provided
        if (!formData.legacyMembership) {
            toast({
                variant: 'destructive',
                title: 'Något gick fel.',
                description: 'Medlemsnummer måste anges.',
            });
            return;
        }

        setIsLoading(true);

        try {
            const response = await api.post(`https://skhrf-api.cmdigital.se/v1/bunnies/import`, {
                ...formData,
            });
            fetchBunnies();
            toast({
                title: 'Kaniner importerade.',
                description: `${response.data.importedCount} kaniner kopplade till medlemsnummer ${formData?.legacyMembership} har importerats.`,
            });

            setIsDialogOpen(false);
        } catch (error) {
            toast({
                variant: 'destructive',
                title: 'Något gick fel.',
                description: error?.response?.data?.error,
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
            <DialogTrigger asChild>
                <Button variant='secondary' className='xl:col-span-2'>
                    <CounterClockwiseClockIcon className='mr-3' />Importera kaniner
                </Button>
            </DialogTrigger>
            <DialogContent className="flex flex-col gap-6">
                <DialogHeader className='text-left'>
                    <DialogTitle>Importera kaniner</DialogTitle>
                    <DialogDescription>Ange ditt medlemsnummer från tidigare system för att importera dina kaniner. Tänk på att det kan finnas kaniner som inte har ett medlemsnummer kopplade till sig och kan därför saknas.</DialogDescription>
                </DialogHeader>
                <Form {...form}>
                    <form onSubmit={handleChange} className="flex flex-col gap-6">
                        <FormField
                            control={form.control}
                            name="legacyMembership"
                            render={({ field }) => (
                                <FormItem className='space-y-0 grid gap-2'>
                                    <FormLabel>Medlemsnummer</FormLabel>
                                    <FormControl>
                                        <Input
                                            id='legacyMembership'
                                            type='text'
                                            placeholder=''
                                            value={formData.legacyMembership}
                                            onChange={(e) => setFormData(prevState => ({ ...prevState, legacyMembership: e.target.value }))}
                                            autoComplete='off'
                                        />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>
                            )}
                        />
                        <div className='grid grid-cols-2 gap-3'>
                            <DialogClose asChild>
                                <Button type='button' variant='secondary'>Avbryt</Button>
                            </DialogClose>
                            <Button
                                onClick={handleChange}
                                disabled={isLoading}>
                                {(isLoading) ? <UpdateIcon className='loader-spinner' /> : 'Importera kaniner'}
                            </Button>
                        </div>
                    </form>
                </Form>
            </DialogContent>
        </Dialog>
    );
};

export default ImportBunniesDialog;
